/* TSC theme JS — marquee + slide-in menu.
   Card holder ships its own script. */
(function () {
  "use strict";

  var reduce =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // ---------- Slide-in menu ----------
  function initMenu() {
    var menu = document.querySelector("[data-tsc-menu]");
    var openBtn = document.querySelector("[data-tsc-menu-open]");
    if (!menu || !openBtn || menu.__tscInit) return;
    menu.__tscInit = true;

    function setOpen(open) {
      menu.classList.toggle("is-open", open);
      menu.setAttribute("aria-hidden", open ? "false" : "true");
      openBtn.setAttribute("aria-expanded", open ? "true" : "false");
      document.body.classList.toggle("tsc-menu-open", open);
    }

    openBtn.addEventListener("click", function () { setOpen(true); });
    menu.querySelectorAll("[data-tsc-menu-close]").forEach(function (el) {
      el.addEventListener("click", function () { setOpen(false); });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") setOpen(false);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMenu);
  } else {
    initMenu();
  }
  document.addEventListener("shopify:section:load", initMenu);

  // ---------- Marquee ----------
  var tracks = document.querySelectorAll(".tsc-marquee__track");
  if (tracks.length) {
    if (reduce) {
      for (var i = 0; i < tracks.length; i++) {
        tracks[i].style.animation = "none";
      }
    }
    document.querySelectorAll(".tsc-marquee").forEach(function (m) {
      m.addEventListener("mouseenter", function () {
        var t = m.querySelector(".tsc-marquee__track");
        if (t) t.style.animationPlayState = "paused";
      });
      m.addEventListener("mouseleave", function () {
        var t = m.querySelector(".tsc-marquee__track");
        if (t) t.style.animationPlayState = "running";
      });
    });
  }
})();

// ─────────── Product Form: variant selector + gallery sync ───────────
(function () {
  'use strict';

  function initProductForm() {
    var form = document.getElementById('ProductForm');
    if (!form) return;

    // Leggi i dati varianti dal JSON iniettato nel Liquid
    var jsonEl = document.getElementById('ProductJSON');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch(e) { return; }
    var variants = product.variants;

    var hiddenId  = form.querySelector('input[name="id"]');
    var priceEl   = document.querySelector('[data-testid="pdp-price"]');
    var addBtn    = form.querySelector('[data-testid="pdp-add"]');
    var gallery   = document.querySelector('[data-testid="pdp-gallery"]');
    var radios    = form.querySelectorAll('.tsc-product__variant-input');

    // Fallback: forza checked sul primo radio di ogni gruppo se nessuno e' checked
    var radioNames = {};
    radios.forEach(function(r) { if (!radioNames[r.name]) radioNames[r.name] = r; });
    Object.keys(radioNames).forEach(function(name) {
      var anyChecked = form.querySelector('input[name="' + name + '"]:checked');
      if (!anyChecked) radioNames[name].checked = true;
    });

    // Trova variante corrispondente alle opzioni correntemente selezionate
    function getSelectedVariant() {
      var selected = {};
      radios.forEach(function (r) {
        if (r.checked) selected[r.name] = r.value;
      });
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return selected['options[' + product.options[i] + ']'] === opt;
        });
      });
    }

    // Aggiorna prezzo, pulsante ATC, input hidden
    function updateForm(variant) {
      if (!variant) return;

      // Aggiorna input hidden
      if (hiddenId) hiddenId.value = variant.id;

      // Aggiorna prezzo
      if (priceEl) {
        var money = (variant.price / 100).toLocaleString('it-IT', {
          style: 'currency', currency: product.currency || 'EUR'
        });
        priceEl.textContent = money;
      }

      // Aggiorna pulsante ATC
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }

      // Aggiorna gallery: scrolla alla prima immagine della variante
      updateGallery(variant);
    }

    // Scrolla gallery alla slide con l'immagine della variante
    function updateGallery(variant) {
      if (!gallery || !variant.featured_image) return;
      var targetSrc = variant.featured_image.src
        .replace(/\/v\d+\//, '/')
        .split('?')[0]
        .split('_')[0];

      var figures = gallery.querySelectorAll('.tsc-product__img');
      figures.forEach(function (fig, i) {
        var img = fig.querySelector('img');
        if (!img) return;
        var figSrc = img.src
          .replace(/\/v\d+\//, '/')
          .split('?')[0]
          .split('_')[0];
        if (figSrc.includes(targetSrc.split('/').pop().split('.')[0].substring(0, 20))) {
          // Scrolla la gallery a questa slide
          gallery.scrollTo({ left: fig.offsetLeft, behavior: 'smooth' });
        }
      });
    }

    // Listener su ogni radio
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        var variant = getSelectedVariant();
        updateForm(variant);
      });
    });

    // Init: aggiorna con variante default
    var initVariant = getSelectedVariant();
    if (initVariant) updateForm(initVariant);
  }

  // Esegui all'avvio e al caricamento sezione Shopify
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductForm);
  } else {
    initProductForm();
  }
  document.addEventListener('shopify:section:load', initProductForm);

})();
